import { defineMessages } from 'react-intl'

const messages = defineMessages({
  referenceRegions: {
    id: 'LinesChart.referenceRegions',
    description: 'Regiones de referencia',
    defaultMessage: 'Reg. referencia'
  },
  femaleAcronym: {
    id: 'LinesChart.femaleAcronym',
    description: 'Texto para mujeres',
    defaultMessage: 'M'
  },
  maleAcronym: {
    id: 'LinesChart.maleAcronym',
    description: 'Texto para hombres',
    defaultMessage: 'H'
  },
  euAcronym: {
    id: 'LinesChart.euAcronym',
    description: 'Texto para UE27',
    defaultMessage: 'UE27 (2020)'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/Charts/Lines/LinesChart/messages.js